module.exports = __webpack_public_path__ + "images/3f52ad5c4b37fd061a4d00f4e3a6a4f832c2f0bfb47c9eb5e34e9da9afd8bcc5.svg";